import type { ReactNode } from 'react';
import { AIStickyTrigger } from '@/components/ui/AIHelperCompact';
import { Footer } from '@/components/ui/Footer';
import { useConfiguration } from '@/contexts/ConfigurationContext';
import { Loader } from '@ophelos/ui/components/loader';

interface LayoutProps {
  children: ReactNode;
  showFooter?: boolean;
}

export function Layout({ children, showFooter = true }: LayoutProps) {
  const { config, isLoading } = useConfiguration();

  // Don't render layout with config-dependent styling until config is loaded
  if (isLoading) {
    return <Loader fullScreen />;
  }

  const showGradientSphere = config.ui.branding.showGradientSphere ?? config.ui.branding.theme === 'approachable';

  return (
    <div className="flex flex-col relative min-h-dvh">
      {/* Main content */}
      <main className="stack flex-1 z-2 ">{children}</main>

      {/* Gradient sphere - sun effect */}
      {showGradientSphere && (
        <div className="fixed -bottom-[25vw] z-1 -left-[15vw] w-[50vw] h-[50vw] bg-radial from-brand-500/35 via-brand-500/15 to-transparent rounded-full blur-3xl" />
      )}

      <AIStickyTrigger reserveSpace={showFooter} />

      {/* Footer */}
      {showFooter && <Footer />}
    </div>
  );
}
